import { ref } from 'vue'

export function getClipboardUtils() {
  const clipboard_copied = ref(false)

  const clipboard_copyToClipboard = (text: string) => {
    clipboard_copied.value = true
    navigator.clipboard.writeText(text)
    setTimeout(() => {
      clipboard_copied.value = false
    }, 1200)
  }

  return {
    clipboard_copied,
    clipboard_copyToClipboard,
  }
}
